import { AuthEnums } from "models/enums";
import { ApiClientInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

/**
 * @deprecated This service is deprecated. Use useUserService hook instead.
 *
 * Migration guide:
 * 1. Replace UserService calls with useUserService hook
 * 2. Use the hook in React components or custom hooks
 * 3. Handle user state through Redux hooks
 *
 * @see useUserService - The replacement hook for user functionality
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 *
 * @example
 * // Old way (deprecated):
 * import { UserService } from "services";
 *
 * const toggles = await UserService.getProfileToggles();
 *
 * @example
 * // New way (recommended):
 * import useUserService from "serviceHooks/useUserService";
 *
 * function UserComponent() {
 *   const { getProfileToggles } = useUserService();
 *   const toggles = await getProfileToggles();
 * }
 */
const UserService = {
  getProfileToggles: () => {
    return ApiClientInstance(AuthEnums.AuthType.User).UserClient.GetProfileToggles();
  },
  getDefaultTodoGroupType: () => {
    return ApiClientInstance(AuthEnums.AuthType.User).UserClient.GetDefaultTodoGroupType();
  },
  updateDefaultTodoGroupType: (type: WintSuperkollAPIModel.TodoGroupType) => {
    return ApiClientInstance(AuthEnums.AuthType.User).UserClient.UpdateDefaultTodoGroupType(type);
  },
};

export default UserService;
